import application from "../sites/jigou";

application();
